module.exports = __webpack_public_path__ + "img/etsy.e201086c.png";